import ClipboardJS from "clipboard"

if ( $('.copy-container-id__button').length > 0 ) {

  $('.copy-container-id__button').on('click', function(e) { e.preventDefault() })
  new ClipboardJS('.copy-container-id__button')

}
